import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopSelectedProjectDifficultyLevel, selectCoopXpBuffFactorForProjectType, } from "../../../selectors/selectCoopInfo";
import { selectRunningCoopProjectEventInfo } from "../../../selectors/selectEventInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilCoopProject } from "../../../utils/utilCoopProject";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
var _CoopProjectInformationHeader = function (_a) {
    var coopProject = _a.coopProject, buffFactor = _a.buffFactor, selectedProjectDifficulty = _a.selectedProjectDifficulty;
    if (!selectedProjectDifficulty) {
        return React.createElement(React.Fragment, null);
    }
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, selectedProjectDifficulty.level.toString(10)],
    ]);
    var coopXpReward = selectedProjectDifficulty.coopXpReward;
    var projectBadgeElement = (React.createElement(React.Fragment, null,
        React.createElement(Icon, { icon: IdIcon.CoopXpIcn, styleId: IdStyles.IconExtraLarge }),
        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: coopXpReward })));
    var tooltipId = IdLoca.tooltip_coopProjects_xpInfo;
    if (buffFactor > 1) {
        coopXpReward = coopXpReward * buffFactor;
        tooltipId = IdLoca.tooltip_coopProjects_eventXpInfo;
        projectBadgeElement = (React.createElement(React.Fragment, null,
            React.createElement(Icon, { icon: IdIcon.CoopXpBoostIcn, styleId: IdStyles.IconExtraLarge },
                React.createElement("div", { className: "flex flex--guts h100" },
                    React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: buffFactor, format: TypeNumberFormat.Multiplication }))),
            React.createElement(NumberFormat, { className: IdStyles.TextPositive, amount: coopXpReward })));
    }
    var tooltipReplacements = new Map([[ReplacementLoca.zero_0, buffFactor.toString(10)]]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement(TextLoca, { id: coopProject.locakey, className: IdStyles.TextButtonHeading }),
            React.createElement(TextLoca, { id: IdLoca.difficultyX, replacements: locaReplacements, className: IdStyles.TextButtonHeading })),
        React.createElement("div", { className: "flex flex--around" },
            React.createElement("div", { className: IdStyles.CoopProjectsDetailsGraphic },
                React.createElement("div", { className: "flex coop-project-background-img coop-project-background_" + coopProject.id })),
            React.createElement(TooltipText, { id: tooltipId, anchor: IdTooltipAnchor.Bottom, replacements: tooltipReplacements },
                React.createElement("div", { className: IdStyles.CoopProjectsStarContainer },
                    React.createElement("div", { className: "flex flex--stacked flex--guts h100" }, projectBadgeElement))))));
};
var mapState = function (state, ownProps) {
    var coopProject = ownProps.coopProject;
    var selectedCoopProjectDifficultyLevel = selectCoopSelectedProjectDifficultyLevel(state);
    return {
        buffFactor: selectCoopXpBuffFactorForProjectType(state, coopProject),
        runningCoopProjectEvent: selectRunningCoopProjectEventInfo(state),
        selectedProjectDifficulty: utilCoopProject.getProjectDifficultyLevelType(coopProject, selectedCoopProjectDifficultyLevel),
    };
};
export var CoopProjectInformationHeader = connect(mapState)(_CoopProjectInformationHeader);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/CoopProjectInformationHeader.tsx
// module id = 2591
// module chunks = 3